<div class="card">
    <div class="card-header">
        <div class="title">{{ 'ORGANIZATION.EMPLOYEES' | translate }}</div>
        <div class="tools">
            <button type="button" class="btn btn-primary btn-sm" (click)="openDialogEmployeeInvitation()">
                <i class="bi bi-plus-circle"></i> {{ 'INVITE' | translate }}
            </button>
        </div>
    </div>
    <div class="card-body">

        <table class="table table-hover">
            <thead>
                <tr>
                    <th scope="col" class="name"       *ngIf="checkColumnForTable('name')">{{ 'EMPLOEE.FULL_NAME' | translate }}</th>
                    <th scope="col" class="department" *ngIf="checkColumnForTable('department')">{{ 'EMPLOEE.DEPARTMENT' | translate }}</th>
                    <th scope="col" class="position"   *ngIf="checkColumnForTable('position')">{{ 'EMPLOEE.POSITION' | translate }}</th>
                    <th scope="col" class="role"       *ngIf="checkColumnForTable('role')">{{ 'ROLE' | translate }}</th>
                    <th scope="col" class="status"     *ngIf="checkColumnForTable('status')">{{ 'STATUS' | translate }}</th>
                    <th scope="col" class="action"     *ngIf="checkColumnForTable('action')">{{ 'ACTION' | translate }}</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let employee of employees; let i = index">
                    <td class="name" *ngIf="checkColumnForTable('name')">
                        <a routerLink="/users/edit/{{ employee.user_id }}">{{ employee.full_name }}</a>
                    </td>
                    <td class="department" *ngIf="checkColumnForTable('department')">
                        <span *ngIf="employee.department; else elseNoDepartment">{{ employee.department.name }}</span>
                        <ng-template #elseNoDepartment>-</ng-template>
                    </td>
                    <td class="position" *ngIf="checkColumnForTable('position')">
                        <span *ngIf="employee.position; else elseNoPosition">{{ employee.position.name }}</span>
                        <ng-template #elseNoPosition>-</ng-template>
                    </td>
                    <td class="role" *ngIf="checkColumnForTable('role')">
                        <span *ngIf="employee.urole; else elseNoURole">{{ employee.urole.name }}</span>
                        <ng-template #elseNoURole>-</ng-template>
                    </td>
                    <td class="status" *ngIf="checkColumnForTable('status')">
                        <span *ngIf="employee.urole; else elseNoURole" 
                            class="state" 
                            [class.active]="employee.state.id == 'ACTIVE'"
                            [class.blocked]="employee.state.id == 'BLOCKED'">
                            {{ employee.state.name }}
                        </span>
                        <ng-template #elseNoURole>-</ng-template>
                    </td>
                    <td class="action" *ngIf="checkColumnForTable('action')">
                        <button type="button" class="btn btn-light" placement="top" ngbTooltip="{{ 'WATCH' | translate }}"  (click)="onProfile(employee.id)">
                            <i class="bi bi-eye"></i>
                        </button>
                        <button type="button" class="btn btn-light" (click)="onEdit(i)" placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                            <i class="bi bi-pencil-square"></i>
                        </button>
                        <!-- <button *ngIf="employee.state.id == 'BLOCKED' && permissionAccess.check('ORGS_USERS_UNBLOCK')" type="button" class="btn btn-light" (click)="onBlock([employee.id], 'unblock')" placement="top" ngbTooltip="{{ 'UNLOCK' | translate }}">
                            <i class="bi bi bi-unlock"></i>
                        </button>
                        <button *ngIf="employee.state.id == 'ACTIVE' && permissionAccess.check('ORGS_USERS_BLOCK')" type="button" class="btn btn-light" (click)="onBlock([employee.id], 'block')" placement="top" ngbTooltip="{{ 'BLOCK' | translate }}">
                            <i class="bi bi bi-lock"></i>
                        </button> -->
                        <button type="button" class="btn btn-light" (click)="onConfirm([employee.id])" placement="top" ngbTooltip="{{ 'DELETE' | translate }}" *ngIf="permissionAccess.check('ORGS_USERS_DELETE')">
                            <i class="bi bi bi-trash"></i>
                        </button>
                    </td>
                </tr>

                <tr *ngIf="employees.length == 0">
                    <td *ngIf="loading" class="data-loading" colspan="6">
                        <div class="spinner-bars">
                            <div class="loadingio-spinner-bars-preLoder-inner">
                                <div class="preLoder">
                                    <div></div><div></div><div></div><div></div>
                                </div>
                            </div>
                            <div>{{ 'LOADING' | translate }}</div>
                        </div>
                    </td>
                    <td *ngIf="!loading" class="data-not-found" colspan="6">
                        <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
    <div class="card-footer">
        <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
    </div>
</div>